<template>
    <u-tab-inline v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-tab-inline>
</template>

<script>
import UTabInline from "@/components/publish/styles/tabs/u-tab-inline.vue";

export default {
    props: {},
    components: {
        UTabInline,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
